import { services } from '../data';

export default function Services() {
  return (
    <section className="section services" id="services">
      <div className="container">
        <div className="section-head" data-reveal>
          <h2 className="display-2">
            What RIME offers.
          </h2>
          <p className="section-lede">
            Four focused services, each built to keep your books accurate and your payroll on time.
          </p>
        </div>

        <div className="service-grid">
          {services.map((service) => (
            <article className={`service-card${service.id === 'bookkeeping' ? ' is-bookkeeping' : ''}`} key={service.id} data-reveal>
              <h3>{service.title}</h3>
              <p className="service-tagline">{service.tagline}</p>
              <ul className="rule-list">
                {service.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
